import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { TMatchForm } from "@/features/match/types/MatchForm";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Grid, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

type TMatchBasicInfoFormProps = {
  defaultValues: Partial<TMatchForm>;
};

export const MatchBasicInfoForm: FCC<TMatchBasicInfoFormProps> = () => {
  const methods = useFormContext<TMatchForm>();
  const { control } = methods;

  return (
    <InnerBox showDivider={false} padding={3}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          基本情報
        </Typography>

        <Grid mt={3} container columnGap={3}>
          <Grid item xs>
            <FormField control={control} name="matchName">
              <Input />
            </FormField>
          </Grid>
          <Grid item xs>
            <FormField control={control} name="licenseNumber">
              <Input readonly />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
